import { Box, SxProps, Theme } from "@mui/material";
import { ReactNode } from "react";

interface OverlayBackgroundProps {
  backgroundImage: string;
  overlayColor?: string;
  minHeight?: string;
  children: ReactNode;
  sx?: SxProps<Theme>;
}

const OverlayBackground: React.FC<OverlayBackgroundProps> = ({
  backgroundImage,
  overlayColor = "rgba(0, 0, 0, 0.5)",
  minHeight = "100vh",
  children,
  sx,
}) => {
  return (
    <Box
      sx={{
        position: "relative",
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        px: 2,
        width: "100%",
        py: { xs: 6, md: 0 },
        ...sx,
      }}
    >
      {/* Overlay oscuro */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: overlayColor,
          zIndex: 1,
        }}
      />

      {/* Contenido encima del fondo */}
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default OverlayBackground;
